module.exports = __webpack_public_path__ + "img/timbreTool.48cfb4fd.png";